// COM-HUBS (2026-08-21): Painel — Dashboard + Metas (+ Onde a Hydrodata ganha, desde 16/10/2026;
// + Mapa de prospecção, desde 20/10/2026; + Roteiros comerciais, desde 23/10/2026).
// Fica na raiz `/comercial` (era o path do Dashboard), então todo link antigo
// pro módulo continua caindo aqui.
import HubAbas, { HubTab } from '../../components/HubAbas';
import ComercialDashboard from '../ComercialDashboard';
import ComercialMetas from '../ComercialMetas';
import OndeGanha from '../comercial-onde-ganha/OndeGanha';
import MapaProspeccao from '../comercial-prospeccao-mapa/MapaProspeccao';
import Roteiros from '../comercial-roteiros/Roteiros';

const TABS: HubTab[] = [
  { key: 'dashboard', label: '📊 Dashboard', perm: 'comercial.dashboard.ver', render: () => <ComercialDashboard /> },
  { key: 'onde-ganha', label: 'Onde a Hydrodata ganha', perm: 'comercial.dashboard.ver', render: () => <OndeGanha /> },
  { key: 'mapa', label: '🗺️ Mapa de prospecção', perm: 'comercial.prospeccao_mapa.ver', render: () => <MapaProspeccao /> },
  { key: 'roteiros', label: '📜 Roteiros comerciais', perm: 'comercial.roteiros.ver', render: () => <Roteiros /> },
  { key: 'metas',     label: '🎯 Metas',     perm: 'comercial.metas.ver',     render: () => <ComercialMetas /> },
];

export default function ComercialPainelHub() {
  return <HubAbas tabs={TABS} />;
}
